<template>
    <fragment>
      <UploadContainer
        :type="'C'"
        :uploadBtnText="$locale('global.uploadPDF')"
        action="/api/cinema/uploadPdf"
        :accept="'.pdf'"
        @onSuccess="({response}) => uploadPDFSuccess(response)"
      ></UploadContainer>
      <el-button class="egl-btn-yellow" @click="dlPDF" style="margin-right: 10px;">ダウンロード</el-button>
    </fragment>
</template>
<script>
  import { setConcessionPDFUrl } from "@/helpers/service/api/concession.js";
  import { setCommercialPDFUrl } from "@/helpers/service/api/commercial.js";
  import { getCinemaDetail } from "@/helpers/service/api/cinema";
  import countDownAlert from "@/utils/countDownAlert";
  import UploadContainer from "@/components/common/UploadContainer";
  export default {
    methods: {
      uploadPDFSuccess(res) {
        if (res.success) {
          const funcMapping = {
            concessionMenuPdf: setConcessionPDFUrl,
            commercialMenuPdf: setCommercialPDFUrl
          }
          const obj = {
            cinemaId: window.localStorage.getItem("cinemaId"),
            path: res.data
          }
          funcMapping[this.uploadType](obj).then(response => {
            if (response.success) {
              countDownAlert({
                content: this.$locale("global.operationSuccessful")
              })
            }
          })
        }
      },
      dlPDF() {
        getCinemaDetail({
          id: window.localStorage.getItem('cinemaId')
        }).then(res => {
          if (res.data && res.data[this.uploadType]) {
            window.open(res.data[this.uploadType])
          }
        })
      },
    },
    props: {
      uploadType: {
        type: String,
        default: () => ''
      }
    },
    components: {
      UploadContainer
    }
  }
</script>